import axios from "axios";
import { getLocalStorageValue, setLocalStorageValue } from 'config/helper'
import { encrypted, decrypted } from 'config/crypto'
import { clearSentryUser } from 'config/sentry';

const debugEncryption = localStorage.getItem("debugApiEncryption") === "true"
// axios.defaults.baseURL = "https://whitesfoodliner.ongrocery.shop/api/v1/";
// const aogEndPointURL = getLocalStorageValue("api-end-point-aog");

// const getBaseUrl = async () =>
//   aogEndPointURL + "/v1/";

export function getBaseUrl() {
  const url = getLocalStorageValue("api-end-point-aog")
  return url + "/v1/";
}

function encryptionEnabled(baseUrl) {
  return baseUrl.includes('wrapperapi') && !baseUrl?.includes("AogAddYourLists")
}

let saveOrderInProgress = false;
export const setSaveOrderInProgress = (value) => { saveOrderInProgress = value; };
const BLOCKED_APIS = ['/AogGetCart', '/AogGetCoupons'];

let axiosInstance = axios.create({
  timeout: 100000,
});

// request inceptors for taking token
axiosInstance.interceptors.request.use(
  (config) => {
    if (saveOrderInProgress && BLOCKED_APIS.some(api => config.url?.toLowerCase()?.includes(api?.toLowerCase()))) {
      return Promise.reject(new Error(`🚫 Blocked during save order: ${config.url}`));
    }
    config.baseURL = getBaseUrl();
    const baseUrl = config.baseURL || '';
    const url = baseUrl + config.url;
    const body = config.data ?? config.params ?? {};

    // Encrypt request data when base URL contains wrapperapi
    // if (baseUrl.includes('wrapperapi') && false) {
    if (encryptionEnabled(url)) {
      const dataToEncrypt = config.data ?? config.params ?? {};
      if (debugEncryption) {
        console.log(`🚀 Payload to Encrypt: ${url}: ${JSON.stringify(dataToEncrypt)}`);
      }
      const isEncryptable = dataToEncrypt && typeof dataToEncrypt === 'object' && !(dataToEncrypt instanceof FormData);
      if (isEncryptable) {
        const encryptedData = encrypted(JSON.stringify(dataToEncrypt));
        config.data = { data: encryptedData };
        config.params = undefined;
      }
    }

    if (debugEncryption) {
      console.log(`📤 Request: ${config.method?.toUpperCase()} ${url}`, baseUrl.includes('wrapperapi') ? '[encrypted]' : body);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// request inceptors for taking token
// axiosInstance.interceptors.request.use(
//     config => {
//       config.headers.authorization = `bearer ${getLocalStorageValue(
//         "user-token")}`
//       return config;
//     },
//     error => Promise.reject(error),
//   );

// response inceptors for handling response
axiosInstance.interceptors.response.use(
  (response) => {
    // Decrypt response data for wrapperapi + AogGetCustomer requests
    const baseUrl = response.config.baseURL || '';
    const url = baseUrl + (response.config.url || '');
    if (encryptionEnabled(url)) {
      try {
        const decryptedData = decrypted(response.data.data);
        response.data = decryptedData ? JSON.parse(decryptedData) : response.data.data;
        if (debugEncryption) {
          console.log(`🍀 Decrypted response: ${url}: ${JSON.stringify(response.data)}`);
        }
      } catch (err) {
        console.error(`🪰 Failed to decrypt response: ${url}: ${err}`);
      }
    }

    if (response.data.status === "token_expired") {
      console.log(`💚 token expired response >>> URL: ${response?.config?.url} - data: ${JSON.stringify(response.data)}`)
      const store = getLocalStorageValue("selected-store-id");
      clearSentryUser();
      localStorage.clear();
      setLocalStorageValue("selected-store-id", store);
      console.log('ℹ️ logged out because token expired! API URL:', response?.config?.url ? response?.config?.baseURL + response?.config?.url : 'unknown');
      window.location.href = "/login";
      return;
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const store = getLocalStorageValue("selected-store-id");
      clearSentryUser();
      localStorage.clear();
      setLocalStorageValue("selected-store-id", store);
      console.log('ℹ️ logged out because of Unauthorized access! API URL:', error?.config?.url ? error?.config?.baseURL + error?.config?.url : 'unknown');
      window.location.href = "/login";
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;